/*
    Copyright (C) 2023 - Wheel and Brake - Southwest Airlines
*/
import React from "react";
import PartForm from "./PartForm";
import "../commons/Form.css";

const CreatePart = () => {
  return (<PartForm />);
};

export default CreatePart;